const { EventEmitter } = require('events')

const { URL_BASE, DEFAULT_LANGUAGE, THEME_NAME } = process.env.CONFIG
const { languages, location } = window

const isDev = process.env.NODE_ENV === 'development'

const BASE_URL = isDev ? URL_BASE : ''

module.exports = {
  SITE: BASE_URL,
  API_BASE_URL: `${BASE_URL}/wp-json`,
  API_CACHE_BASE_URL: `${BASE_URL}/api/wp-json`,
  CURRENT_LANG: DEFAULT_LANGUAGE !== '' ? `/${DEFAULT_LANGUAGE}` : '/',
  LANGUAGES: languages || [],
  PATH: languages.length > 1 ? `${location.pathname.split('/')[1]}/` : '',
  COOKIE_POLICY_NAME: `user-has-accepted-cookies-${THEME_NAME}`,
  DIST_URL: `${BASE_URL}/wp-content/themes/${THEME_NAME}/dist/`,
  GF_CONSUMER_KEY: 'ck_2f9f441e5625053d03e3e90c9cb75c6f635a9cf8',
  GF_CONSUMER_SECRET: 'cs_29aa5fb827d75814d889794b6f2ce70e4b28220f',
  API: {
    BASE_URL: '/wp/v2',
    MENU: '/gusto/nav',
    MENU_LOCATIONS: '/gusto/nav/menu-locations',
    PAGE: '/wp/v2/pages',
    POST: '/wp/v2/posts',
    CONFIGURATION: '/wp/v2/configurazione',
    TAXONOMY: '/taxonomies',
    CF7_FEEDBACK: '/contact-form-7/v1/contact-forms',
    CF7_GET: '/gusto/form',
    GF_GET: '/gf/v2/forms',
    ROUTING: '/gusto/routing-rules',
    LOCALES: '/gusto/language',
    STRINGS: '/gusto/strings',
    FILESYSTEM: '/wp/v2/wpfs',
  },
  CONFIG: {
    THEME_NAME,
    LINK_DELAY: 0,
    CUSTOM_TYPE_PREFIX: '_cty_',
    CUSTOM_TAXONOMY_PREFIX: '_cta_',
    RECAPTCHA_SITE_KEY: window.g_recaptcha_sitekey || '',
  },
  webgl: {
    PERFORMANCE_DETECT: true,
    GPU_BLACKLIST: ['radeon hd 6970m', 'radeon hd 6770m', 'radeon hd 6490m', 'radeon hd 6630m', 'radeon hd 6750m', 'radeon hd 5750', 'radeon hd 5670', 'radeon hd 4850', 'radeon hd 4870', 'radeon hd 4670', 'geforce 9400m', 'geforce 320m', 'geforce 330m', 'geforce gt 130', 'geforce gt 120', 'geforce gtx 285', 'geforce 8600', 'geforce 9600m', 'geforce 9400m', 'geforce 8800 gs', 'geforce 8800 gt', 'quadro fx 5', 'quadro fx 4', 'radeon hd 2600', 'radeon hd 2400', 'radeon hd 2600', 'radeon r9 200', 'mali-4', 'mali-3', 'mali-2'],
  },
  EMITTER: new EventEmitter(),
  EVENTS: {
    DATALAYER: {
      COOKIE_CONSENT: 'cookie-consent',
    },
  },
  PREVIEW_KEY: 'ciam-prev',
}
